import React, { Component } from "react";
import { Header, Table, Segment } from "semantic-ui-react";
import { apiUrl } from "../../utils/constants";

class HelpXml extends Component {
  render() {
    return (
      <Segment basic>
        <Header as="h3">
          <Header.Subheader>
            Your Event Details XML feed is located here:
          </Header.Subheader>
          <a href={apiUrl() + "/feeds/event-details"} target="_blank" rel="noopener noreferrer">
            {apiUrl() + "/feeds/event-details"}
          </a>
        </Header>
        <p>
          This feed provides a sales breakdown which may be used on external
          websites.
        </p>
        <Table striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell colSpan="2">
                Available XML Elements:
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            <Table.Row>
              <Table.Cell>event_id</Table.Cell>
              <Table.Cell>The system assigned ID for this event.</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>event_title</Table.Cell>
              <Table.Cell>The name of the event.</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>date</Table.Cell>
              <Table.Cell>The date of the event</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>jackpot</Table.Cell>
              <Table.Cell>
                The net jackpot as a raw, unformatted number.
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>prize</Table.Cell>
              <Table.Cell>
                The prize as a raw, unformatted number (prize = net jackpot
                divided by 2).
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>tickets</Table.Cell>
              <Table.Cell>The number of tickets sold</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>numbers</Table.Cell>
              <Table.Cell>The count of raffle numbers in the draw</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>total_sales</Table.Cell>
              <Table.Cell>Net Sales for the event</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>total_cash</Table.Cell>
              <Table.Cell>Net Cash Sales for the event</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>total_credit</Table.Cell>
              <Table.Cell>Net Credit Sales for the event</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>pricepoints</Table.Cell>
              <Table.Cell>
                An array of nodes containing a break down of sales by price
                point
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>locations</Table.Cell>
              <Table.Cell>
                An array of nodes containing a break down of sales by location
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
        <Table striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell colSpan="2">
                Price Point Node Elements:
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            <Table.Row>
              <Table.Cell>quantity</Table.Cell>
              <Table.Cell>The count of numbers in this price point</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>price</Table.Cell>
              <Table.Cell>The cost this price point</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>total_tickets</Table.Cell>
              <Table.Cell>
                How many tickets were sold at this price point
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>total_numbers</Table.Cell>
              <Table.Cell>
                How many numbers were generated at this price point
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>total_sales</Table.Cell>
              <Table.Cell>Net Sales for this price point</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>total_sales_cash</Table.Cell>
              <Table.Cell>Net Cash Sales for this price point</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>total_sales_credit</Table.Cell>
              <Table.Cell>Net Credit Sales for this price point</Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
        <Table striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell colSpan="2">
                Location Node Elements:
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            <Table.Row>
              <Table.Cell>id</Table.Cell>
              <Table.Cell>The system ID for this location</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>rank</Table.Cell>
              <Table.Cell>
                The rank of this location (ordered by total_sales)
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>name</Table.Cell>
              <Table.Cell>The name of this location</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>total_tickets</Table.Cell>
              <Table.Cell>
                How many tickets were sold at this location
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>total_numbers</Table.Cell>
              <Table.Cell>
                How many numbers were generated at this location
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>total_sales</Table.Cell>
              <Table.Cell>Net Sales for this location</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>total_sales_cash</Table.Cell>
              <Table.Cell>Net Cash Sales for this location</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>total_sales_credit</Table.Cell>
              <Table.Cell>Net Credit Sales for this location</Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </Segment>
    );
  }
}

export default HelpXml;
